module.exports = __webpack_public_path__ + "static/Cuauhtemoc-Moctezuma-Holding-–-Tecate-Beer-bcd0c414b7229d6b5f0d786f47ec76d4.png";